import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function DarkExecutiveTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug overflow-hidden" data-testid="resume-live-preview">
      <div className="p-6 bg-[#0b0f19]">
        <h1 className="text-2xl font-bold text-white">{draft.full_name || "Your Name"}</h1>
        <p className="text-xs mt-1 font-semibold" style={{ color: accent }}>{draft.target_role}</p>
        <p className="text-slate-400 text-[11px] mt-1">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
      </div>
      <div className="p-6">
        {draft.summary && (
          <div>
            <h2 className="text-xs font-bold uppercase tracking-wider border-b pb-1" style={{ color: accent, borderColor: accent }}>Summary</h2>
            <p className="text-slate-700 mt-1.5">{draft.summary}</p>
          </div>
        )}
        {draft.skills.length > 0 && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider border-b pb-1" style={{ color: accent, borderColor: accent }}>Skills</h2>
            <p className="text-slate-700 mt-1.5">{draft.skills.join(" • ")}</p>
          </div>
        )}
        {draft.experience.length > 0 && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider border-b pb-1" style={{ color: accent, borderColor: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mt-2">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider border-b pb-1" style={{ color: accent, borderColor: accent }}>Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mt-1.5"><span className="font-semibold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school} <span className="text-slate-400 italic">({ed.start_date} - {ed.end_date})</span></p>)}
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
